export default __webpack_public_path__ + "static/media/too_much_messages.a9fe2a12.svg";